export const bumpRequestsNumberVersion = () => {
  const serverRequestsVersion = localStorage.getItem('serverRequestsVersion');
  const versionNum = parseInt(serverRequestsVersion, 10);
  if (!isNaN(versionNum)) {
    const newValue = versionNum + 1;
    localStorage.setItem('serverRequestsVersion', newValue);
    const event = new StorageEvent('storage', {
      key: 'serverRequestsVersion',
      versionNum,
      newValue,
    });
    window.dispatchEvent(event);
  }
};
